<template>
  <b-modal
    id="invitation-delete-modal"
    ref="invitationDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to revoke member invitation for this user?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MemberInvitationDeleteModal',
  props: {
    memberp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      invitationDeleted: 'merchant/invitationDeleted',
      apiError: 'merchant/apiError',
    }),
  },
  watch: {
    invitationDeleted(deleted) {
      if (deleted) {
        this.deleting = false;
        this.$emit('deleted', deleted);
        this.$refs.invitationDeleteModal.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteInvitation: 'merchant/deleteInvitation',
    }),
    commitDelete() {
      this.deleting = true;
      this.deleteInvitation({
        merchant_id: this.$route.params.merchant_id,
        invitation_id: this.memberp.id,
      });
    },
    show() {
      this.$refs.invitationDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.invitationDeleteModal.hide();
    },
  },
};
</script>
